import { request } from "@insite/client-framework/Services/ApiService";

export interface SearchItemByTypeParameter {
    ProductNames:string;
    ProductType: string;
    ProductBrand: string;
}

export interface SearchItemByTypeResult{
    available?: string[];
    notavailable?: string[]
}

export const url ="api/v2/GetProductByItemType"

export async function GetSearchItemByItemType(param: SearchItemByTypeParameter){
    const response =  request<SearchItemByTypeResult>(url,"POST",{"Content-Type": "application/json",},JSON.stringify(param));
    return response;
}